/* ============================================================================
   Petpal PDP JS — ported from "Product.dc.html" render.
   Header / logo / nav / footer / cart-drawer responsive + toggling live in
   pp-theme.js (global). This file owns ONLY the product-page body:
     • image gallery (main image + thumbnail switching)
     • Subscribe & Save  vs  One-time toggle  → wired to the real product form
       (sets the hidden `selling_plan` input, swaps the shown price, the
       add-to-cart label and the sticky-bar label/subline)
     • quantity stepper (bound to the form's qty input)
     • body responsive grids  (PDP grid, benefits, ingredients, mechanism,
       timeline, splits, reviews, pairs)
     • sticky add-to-cart reveal on scroll
     • live @petpalfoods Instagram feed via Behold (feed ncjauuQ14gsUR8GRetzS)
   All product/price data comes from data- attributes the Liquid section prints,
   so this file never hard-codes a catalog.
   ========================================================================== */
(function () {
  function ready(fn) { document.readyState !== 'loading' ? fn() : document.addEventListener('DOMContentLoaded', fn); }
  function icons() { if (window.lucide && window.lucide.createIcons) { try { window.lucide.createIcons(); } catch (e) {} } }

  /* ---------- image gallery: click a thumb → swap the main image ---------- */
  function setupGallery() {
    var root = document;
    var main = root.querySelector('[data-pdp-main]');
    var thumbs = root.querySelectorAll('[data-pdp-thumb]');
    if (!main || !thumbs.length) return;
    function select(btn) {
      var src = btn.getAttribute('data-src');
      if (src) main.setAttribute('src', src);
      thumbs.forEach(function (t) {
        var on = t === btn;
        t.style.border = on ? '2px solid #C29A52' : '1px solid #ece4d6';
      });
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { select(t); }); });
  }

  /* ---------- subscribe / one-time purchase toggle ---------- */
  function setupPurchaseToggle() {
    var root = document;
    var opts = root.querySelectorAll('[data-buyopt]');
    if (!opts.length) return;

    var planInput = root.querySelector('[data-selling-plan-input]');
    var atcBtns = root.querySelectorAll('[data-atc-label]');
    var subLines = root.querySelectorAll('[data-atc-subline]');

    function money(cents) {
      var s = (Math.round(cents) / 100).toFixed(2);
      return '$' + s.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    function qtyVal() {
      var q = root.querySelector('[data-qty-input]');
      var n = q ? parseInt(q.value, 10) : 1;
      return (isNaN(n) || n < 1) ? 1 : n;
    }

    function apply(opt) {
      var isSub = opt.getAttribute('data-buyopt') === 'sub';
      var unit = parseInt(opt.getAttribute('data-unit-price'), 10) || 0;   // cents, per unit for this option
      var planId = opt.getAttribute('data-plan-id') || '';
      var soldOut = opt.getAttribute('data-soldout') === 'true';

      // radio visuals + remember which option is selected
      opts.forEach(function (o) {
        var on = o === opt;
        o.setAttribute('data-selected', on ? 'true' : 'false');
        o.style.border = '2px solid ' + (on ? '#C29A52' : '#ece4d6');
        o.style.background = on ? '#FFFDF7' : '#fff';
        var radio = o.querySelector('[data-buyradio]');
        var dot = o.querySelector('[data-buydot]');
        if (radio) radio.style.border = '2px solid ' + (on ? '#C29A52' : '#c3cbd3');
        if (dot) dot.style.display = on ? 'block' : 'none';
      });

      // hidden selling_plan input drives whether the cart line is a subscription
      if (planInput) planInput.value = isSub ? planId : '';

      // price shown on the button + sticky bar
      var line = unit * qtyVal();
      var priceStr = money(line);
      atcBtns.forEach(function (b) {
        if (soldOut) { b.textContent = 'Sold out'; return; }
        b.textContent = 'Add to cart · ' + priceStr;
      });
      subLines.forEach(function (s) {
        s.textContent = isSub
          ? ('Subscribe & save 20% · ' + money(unit) + '/jar')
          : ('One-time · ' + money(unit) + '/jar');
      });
    }

    opts.forEach(function (o) { o.addEventListener('click', function () { apply(o); }); });

    // qty changes should re-price the currently selected option
    var qtyInput = root.querySelector('[data-qty-input]');
    if (qtyInput) {
      qtyInput.addEventListener('change', function () {
        var sel = root.querySelector('[data-buyopt][data-selected="true"]') || opts[0];
        if (sel) apply(sel);
      });
    }

    // initialise on the pre-selected (subscribe) option
    var initial = root.querySelector('[data-buyopt][data-selected="true"]') || opts[0];
    if (initial) apply(initial);
  }

  /* ---------- quantity stepper ---------- */
  function setupQty() {
    var root = document;
    var input = root.querySelector('[data-qty-input]');
    var dec = root.querySelector('[data-qty-dec]');
    var inc = root.querySelector('[data-qty-inc]');
    var out = root.querySelector('[data-qty-display]');
    if (!input) return;
    function render() {
      var n = parseInt(input.value, 10);
      if (isNaN(n) || n < 1) n = 1;
      if (n > 9) n = 9;
      input.value = n;
      if (out) out.textContent = n;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    if (dec) dec.addEventListener('click', function () { input.value = (parseInt(input.value, 10) || 1) - 1; render(); });
    if (inc) inc.addEventListener('click', function () { input.value = (parseInt(input.value, 10) || 1) + 1; render(); });
    render();
  }

  /* ---------- body responsive grids (mirrors render applyResponsive) ---------- */
  function applyResponsive() {
    var root = document, w = window.innerWidth;
    var grids = function (sel, cols) { var el = root.querySelector(sel); if (el) el.style.gridTemplateColumns = cols; };
    var setp = function (sel, prop, val) { var el = root.querySelector(sel); if (el) el.style[prop] = val; };
    var mob = w <= 640, tab = w <= 880;
    grids('[data-pdpgrid]', tab ? '1fr' : '1fr 1fr');
    setp('[data-gallery]', 'position', tab ? 'static' : 'sticky');
    grids('[data-benefits]', mob ? '1fr 1fr' : 'repeat(4,1fr)');
    grids('[data-ings]', mob ? '1fr 1fr' : (tab ? 'repeat(2,1fr)' : 'repeat(4,1fr)'));
    grids('[data-bundleitems]', tab ? '1fr' : 'repeat(3,1fr)');
    grids('[data-mech]', mob ? '1fr 1fr' : 'repeat(4,1fr)');
    grids('[data-timeline]', tab ? '1fr' : 'repeat(3,1fr)');
    root.querySelectorAll('[data-split]').forEach(function (el) { el.style.gridTemplateColumns = tab ? '1fr' : (el.getAttribute('data-cols') || '1fr 1fr'); });
    grids('[data-revgrid]', tab ? '1fr' : '.85fr 1.15fr');
    grids('[data-pairs]', mob ? '1fr 1fr' : (tab ? 'repeat(2,1fr)' : 'repeat(4,1fr)'));
    setp('[data-satcinfo]', 'display', mob ? 'none' : 'flex');
  }

  /* ---------- sticky ATC reveal on scroll ---------- */
  function setupStickyAtc() {
    var el = document.querySelector('[data-satc]');
    if (!el) return;
    var onScroll = function () {
      var y = window.scrollY || document.documentElement.scrollTop;
      el.style.transform = (y > 640) ? 'translateY(0)' : 'translateY(100%)';
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- live @petpalfoods feed via Behold JSON ---------- */
  function loadInstagram() {
    var grid = document.querySelector('[data-pdp-iggrid]');
    if (!grid) return;
    fetch('https://feeds.behold.so/ncjauuQ14gsUR8GRetzS').then(function (r) { return r.json(); }).then(function (d) {
      var fmt = function (n) { return n >= 1000 ? (n / 1000).toFixed(1).replace(/\.0$/, '') + 'k' : ('' + (n || 0)); };
      var posts = (d.posts || []).slice(0, 6).map(function (p) {
        var s = (p.sizes && (p.sizes.medium || p.sizes.small || p.sizes.large)) || {};
        return { src: s.mediaUrl || p.thumbnailUrl || p.mediaUrl, alt: (p.caption || 'petpalfoods on Instagram').slice(0, 80), likes: fmt(p.likeCount), href: p.permalink };
      }).filter(function (p) { return p.src; });
      if (!posts.length) return;
      var igSvg = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line></svg>';
      grid.innerHTML = posts.map(function (ig) {
        var href = ig.href || 'https://www.instagram.com/petpalfoods/';
        return '<a href="' + href + '" target="_blank" rel="noopener" class="ig-tile" style="position:relative;display:block;aspect-ratio:1;border-radius:16px;overflow:hidden;background:#EDE7DB">'
          + '<img src="' + ig.src + '" alt="' + (ig.alt || '').replace(/"/g, '&quot;') + '" style="width:100%;height:100%;object-fit:cover;display:block" loading="lazy">'
          + '<div class="ig-ov" style="position:absolute;inset:0;background:rgba(0,31,54,.42);display:flex;flex-direction:column;align-items:center;justify-content:center;gap:8px;color:#fff">'
          + '<span class="lic" style="width:26px;height:26px">' + igSvg + '</span>'
          + '<span style="display:inline-flex;align-items:center;gap:6px;font-size:13px;font-weight:600"><span class="lic" style="width:15px;height:15px"><i data-lucide="heart"></i></span>' + ig.likes + '</span>'
          + '</div></a>';
      }).join('');
      icons();
    }).catch(function () {});
  }

  /* dog-size / serving selector — cosmetic guide; click to highlight the chosen size */
  function setupSizes() {
    var btns = document.querySelectorAll('[data-sizes] [data-size]');
    if (!btns.length) return;
    function select(btn) {
      btns.forEach(function (b) {
        var on = (b === btn);
        b.style.borderColor = on ? '#001f36' : '#e2d9c8';
        b.style.background = on ? '#001f36' : '#fff';
        b.style.color = on ? '#F5F3EE' : '#001f36';
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }
    btns.forEach(function (b) { b.addEventListener('click', function () { select(b); }); });
  }

  ready(function () {
    setupGallery();
    setupQty();
    setupPurchaseToggle();
    setupSizes();
    applyResponsive();
    setupStickyAtc();
    loadInstagram();
    icons();

    var onResize = function () { applyResponsive(); };
    window.addEventListener('resize', onResize);
    window.addEventListener('load', onResize);
    [150, 500, 1100].forEach(function (t) { setTimeout(applyResponsive, t); });
  });
})();
